


//cart.js
export const SET_SHOPPING_CART = 'SET_SHOPPING_CART'
export const SET_PROMOTIONS_SHOPPING_CART = 'SET_PROMOTIONS_SHOPPING_CART'
export const CART_SET = (set_mutation) => { return 'cart/' + set_mutation }

//common.js
export const SET_EXCHANGE_RATE = 'SET_EXCHANGE_RATE'
export const SET_CLASSIFY_LIST = 'SET_CLASSIFY_LIST'
export const SET_BRAND_LIST = 'SET_BRAND_LIST'
export const SET_POPULARITY_BRANDS = 'SET_POPULARITY_BRANDS'
export const SET_POPULARITY_BRANDS_INIT = 'SET_POPULARITY_BRANDS_INIT'
export const COMMON_SET = (set_mutation) => { return 'common/' + set_mutation }

//goods.js
export const SET_SEARCH_PARAMS = 'SET_SEARCH_PARAMS'
export const SET_HOT_GOODS = 'SET_HOT_GOODS'
export const SET_SPECIAL_AREA = 'SET_SPECIAL_AREA'
export const SET_SPECIAL_AREA_LIST_INIT = 'SET_SPECIAL_AREA_LIST_INIT'
export const SET_SPECIAL_AREA_LIST = 'SET_SPECIAL_AREA_LIST'
export const GOODS_SET = (set_mutation) => { return 'goods/' + set_mutation }

//user.js
export const SET_TOKEN = 'SET_TOKEN'
export const SET_NICKNAME = 'SET_NICKNAME'
export const SET_LEVEL = 'SET_LEVEL'
export const SET_USERNAME = 'SET_USERNAME'
export const SET_ADDRESS_LIST = 'SET_ADDRESS_LIST'
export const SET_BALANCE = 'SET_BALANCE'
export const SET_INTEGRAL = 'SET_INTEGRAL'
export const USER_SET = (set_mutation) => { return 'user/' + set_mutation }

//order.js
export const SET_GOODS_LIST = 'SET_GOODS_LIST'
export const SET_PROMOTION = 'SET_PROMOTION'
export const SET_PROMOTION_GOODS_LIST = 'SET_PROMOTION_GOODS_LIST'
export const SET_DELIVERY_TYPE = 'SET_DELIVERY_TYPE'
export const SET_PICKUP = 'SET_PICKUP'
export const SET_ADDRESS = 'SET_ADDRESS'
export const SET_ACTIVE = 'SET_ACTIVE'
export const SET_PAY_TYPE = 'SET_PAY_TYPE'
export const SET_TRANSACTION_CODE = 'SET_TRANSACTION_CODE'
export const SET_FREIGHT = 'SET_FREIGHT'
export const SET_ORDER_NO = 'SET_ORDER_NO'
export const ORDER_SET = (set_mutation) => 'order/' + set_mutation





// WEBPACK FOOTER //
// ./src/store/mutation-types.js